import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Button from 'components/Button';
import Field from './Field';
import { useForm } from './Form';

const SingleStepForm = ({ questions, handleSubmit, account }) => {
  const form = useForm();

  const onSubmit = () => {
    return form
      .validateFields()
      .then(handleSubmit)
      .catch((e) => {
        console.log(e);
      });
  };

  const elements = questions.map((question, idx) => {
    return (
      <Box mb={2}>
        <Field
          account={account}
          autoFocus={idx === 0}
          name={idx}
          field={question}
          key={question.id}
        />
      </Box>
    );
  });

  return (
    <Box>
      {elements}
      <Box textAlign="center" mt={3}>
        <Button fullWidth size="large" onClick={onSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default SingleStepForm;
